import * as Yup from "yup";
import { FIELD_REQUIRED_MESSAGE } from "../utils/validations";

export const createRoomInitialValues = {
  name: "",
  description: "",
  color: "#A7BED3",
};

export const createRoomValidationSchema = Yup.object({
  name: Yup.string().required(FIELD_REQUIRED_MESSAGE),
  description: Yup.string().required(FIELD_REQUIRED_MESSAGE),
  color: Yup.string().required(FIELD_REQUIRED_MESSAGE),
});

export type CreateRoomValues = typeof createRoomInitialValues;
